import client from './client'

export async function getMyInviteCode() {
  try {
    const response = await client.get('/invite/my-code')
    return response.data
  } catch (error) {
    if (error.response?.data) return error.response.data
    return {
      code: 0,
      message: error.message || '获取邀请码失败'
    }
  }
}

export async function getInviteStats() {
  try {
    const response = await client.get('/invite/stats')
    return response.data
  } catch (error) {
    if (error.response?.data) return error.response.data
    return {
      code: 0,
      message: error.message || '获取邀请统计失败'
    }
  }
}

export async function getInviteRecords(params = {}) {
  try {
    const limit = params.pageSize || params.limit || 20
    const page = params.page || 1
    const offset = params.offset ?? (page - 1) * limit
    const response = await client.get('/invite/records', {
      params: { limit, offset }
    })
    return response.data
  } catch (error) {
    if (error.response?.data) return error.response.data
    return {
      code: 0,
      message: error.message || '获取邀请记录失败'
    }
  }
}

export async function bindInvite(attribution = {}) {
  try {
    const response = await client.post('/invite/bind', {
      invite_code: attribution.invite_code,
      attribution_source: attribution.attribution_source || 'pc_invite',
      utm_params: attribution.utm_params || {}
    })
    return response.data
  } catch (error) {
    if (error.response?.data) return error.response.data
    return {
      code: 0,
      message: error.message || '邀请关系绑定失败'
    }
  }
}
